export const MIN_DISTANCE = 0.00001
export const MARKER_COLORS_SALE = {
  default: '#E85629',
  viewed: '#FE9677',
  text: '#FFFFFF',
  hover: '#F89911',
  offMarket: '#525455',
  offMarketViewed: '#A1A1A1'
}

export const MARKER_COLORS_RENTAL = {
  default: '#4D7E7F',
  viewed: '#90ACAD',
  text: '#FFFFFF',
  hover: '#F89911',
  offMarket: '#525455',
  offMarketViewed: '#A1A1A1'
}

export const polygonBaseStyle = {
  fillColor: 'transparent',
  strokeColor: '#3e807f',
  strokeOpacity: 1,
  strokeWeight: 2,
  clickable: false
}

export const searchPolygonStyle = {
  fillOpacity: 0.2,
  strokeWeight: 2,
  strokeOpacity: 0.5,
  clickable: false
}
